import { Pair } from './BoardUtils';
export const TILE_RATIO: number = 410 / 488;

const BoardSizing = {
    getHighestLayer(pos: number[][]) {
        return pos.reduce((acc, tile) => {
            return Math.max(acc, tile[0]);
        }, 0);
    },

    getLargest(pos: number[]): number {
        return pos.sort((a, b) => a - b)[pos.length - 1];
    },

    getSmallest(pos: number[]): number {
        return pos.sort((a, b) => a - b)[0];
    },

    // dimensions of board arrangement, and the offset from origin
    getLevelVisualUnits(pos: number[][]): [Pair, Pair] {
        const maxX = this.getLargest(pos.map(c => c[1]));
        const maxY = this.getLargest(pos.map(c => c[2]));
        const minX = this.getSmallest(pos.map(c => c[1]));
        const minY = this.getSmallest(pos.map(c => c[2]));
        const visualX = maxX - minX + 1;
        const visualY = maxY - minY + 1;
        return [[visualX, visualY], [minX, minY]];
    },

    // fit to possible proportions, board will be able to scale up from 7,8 to 5 6 board
    getFullBoardUnits(dims: Pair): Pair {
        const len = Math.max(dims[0], dims[1]);
        const targetIndex = dims.indexOf(len);
        const possibleSizes: Pair[] = [[5, 6], [6, 7], [7, 8]]; // configs
        const matchLengths = possibleSizes.reduce((acc, sizeSet) => {
            acc.push(sizeSet[targetIndex]);
            return acc;
        }, []);

        const filteredLength = matchLengths.filter(a => a >= len);
        const closest = filteredLength.reduce((prev, curr) => {
            return curr - len < prev - len ? curr : prev;
        });

        return possibleSizes[matchLengths.indexOf(closest)];
    },

    getTileSize(areaSize: Pair, unitSize: Pair): Pair {
        const tileWidth: number = areaSize[0] / unitSize[0];
        const tileHeight: number = tileWidth / TILE_RATIO;
        return [tileWidth, tileHeight];
    },
};

export default BoardSizing;
